<template>
  <el-form-item :label="this.label">

  <el-cascader
    v-model="value"
    :options="options"
    @change="userUpdated"
    :disabled="disabled"
     lazy>
  </el-cascader>

  <el-checkbox
    v-if="isManager()"
    label="Manager"
    v-model="man"
   />

  </el-form-item>

</template>

<script>

export default {

  name: 'select-users',

  props: {

    label: {
      type: String,
      default: 'Name'
    },

    value: {
      required: true
    },

    manager: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: true
    }

  },

  methods: {

    userUpdated (value) {
      this.role = value
      this.$emit('input', this.role[1])
      this.$emit('change', this.role[1])
    }

  },


  data () {

    return {
      // XOL-446: `roleGroups` is only populated by the authenticated
      // `GET system/config`. Before that resolves — and for the window
      // between a session teardown and the next login — it is the empty
      // default, so fall back to {} and let created() below no-op rather
      // than throwing inside data()/created() and collapsing the component.
      roleGroup: this.getConfig().roleGroups || {},
      man: this.manager,
      role: this.value,
      options: [
        {
          value: 'admin',
          label: 'Admin',
          children: []
        },
        {
          value: 'finance',
          label: 'Finance',
          children: []
        },
        {
          value: 'maintenance',
          label: 'Maintenance',
          children: []
        },
        {
          value: 'management',
          label: 'Management',
          children: []
        },
        {
          value: 'project',
          label: 'Projects',
          children: []
        },
        {
          value: 'property',
          label: 'Property',
          children: []
        },
      ]
    }
  },

  created () {

    let role = this.roleGroup[this.options[0].value] || []

    for (let i = 0; i < role.length; i++) {
//      if (this.manager === this.options[0].manager) {

        if (this.manager === role[i].manager) {
//          console.log('role', role[i].manager)

        this.options[0].children[i] = {
          value: role[i].name,
          label: role[i].name
        }

      }
    }

    role = this.roleGroup[this.options[1].value] || []
    for (let i = 0; i < role.length; i++) {
//      if (this.manager === this.options[1].manager) {
        this.options[1].children[i] = {
          value: role[i].name,
          label: role[i].name
        }
//      }
    }


    role = this.roleGroup[this.options[2].value] || []
    for (let i = 0; i < role.length; i++) {
        this.options[2].children[i] = {
          value: role[i].name,
          label: role[i].name
        }
    }

    role = this.roleGroup[this.options[3].value] || []
    for (let i = 0; i < role.length; i++) {
        this.options[3].children[i] = {
          value: role[i].name,
          label: role[i].name
        }
    }


    role = this.roleGroup[this.options[4].value] || []
    for (let i = 0; i < role.length; i++) {
        this.options[4].children[i] = {
          value: role[i].name,
          label: role[i].name
        }
    }


    role = this.roleGroup[this.options[5].value] || []
    for (let i = 0; i < role.length; i++) {
        this.options[5].children[i] = {
          value: role[i].name,
          label: role[i].name
        }
    }


  }

}
</script>

<style scoped>
.el-cascader {display: inline-block; width: 100%;}
</style>
